import { render, staticRenderFns } from "./customer-statement-list.vue?vue&type=template&id=aa90e48a"
import script from "./customer-statement-list.vue?vue&type=script&lang=js"
export * from "./customer-statement-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports